var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImpressionVideoBlk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.584,
    viewBox: "0 0 18 15.584",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,6.741A10.05,10.05,0,0,0,0,11.8a10.05,10.05,0,0,0,9,5.063A10.05,10.05,0,0,0,18,11.8,10.049,10.049,0,0,0,9,6.741ZM1.3,11.8A8.446,8.446,0,0,1,5.506,8.5a4.777,4.777,0,0,0,0,6.616A8.446,8.446,0,0,1,1.3,11.8ZM9,15.5a3.7,3.7,0,1,1,3.7-3.7A3.7,3.7,0,0,1,9,15.5Zm3.493-.39a4.777,4.777,0,0,0,0-6.617A8.445,8.445,0,0,1,16.7,11.8a8.446,8.446,0,0,1-4.208,3.312Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.449,
    cy: 1.449,
    r: 1.449,
    transform: "translate(7.551 10.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.87,5.616l1.408-.741,1.408.741L3.417,4.048l1.139-1.11L2.982,2.709l-.7-1.426-.7,1.426L0,2.938l1.139,1.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.436,5.616l1.408-.741,1.408.741L9.983,4.048l1.139-1.11L9.548,2.709l-.7-1.426-.7,1.426-1.574.229L7.7,4.048Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,5.616l1.408-.741,1.408.741-.269-1.568,1.139-1.11-1.574-.229-.7-1.426-.7,1.426-1.574.229,1.139,1.11Z",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImpressionVideoBlk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/impression-video-blk.e0e7f572bc710592d1e9e9bcbc0db6cf.svg";